import { RootState } from "@circuitry-ai/doc-data";
import { Button, Divider, Input, Spacer } from "@nextui-org/react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";


export default function PasswordSettings() {
  const { t } = useTranslation();
  const { details: user } = useSelector((state: RootState) => state.auth.user);

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col gap-1 my-3">
        <div className="font-poppins text-lg font-semibold leading-7 text-left">{t('Email Address')}</div>
        <p className="font-poppins text-sm font-normal leading-5 text-left text-default-600">{t('Get your projects up and running faster by inviting your team to collaborate.')}</p>
      </div>
      <Divider />
      <div>
        <div className="py-3 sm:flex gap-3">
          <div className="sm:w-[60%]">
            <label id="email" className='text-sm font-medium' >{t('Current Email')}</label>
            <p className="mt-1 text-sm font-normal text-default-400">
              {t('This will be displayed in your Advisors chat interface')}
            </p>
          </div>
          <div className="sm:w-[100%]">
            <Input id="email" className="mt-2" variant="bordered" fullWidth={true} size="sm" value={user?.email} isDisabled placeholder={t('Company Name')} />
          </div>
        </div>
        <div className="flex gap-2 sm:justify-end">
          <Button id="cancel-button" variant="flat" className="max-sm:flex-1" size="sm">
            {t('Cancel')}
          </Button>
          <Button id="save-button" color="primary" className="max-sm:flex-1" size="sm">
            {t('Save')}
          </Button>
        </div>
      </div>
    </div>
  );
}

